/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-unused-vars: 0, no-var: 0 */
/* globals _, Backbone, MktoForms2, mixpanel, mp */

var contact_form_tpl = require(`./templates/contact_form.pug`);

_.namespace(`Backbone.widgets`, function(ns) {
  "use strict";

  var ContactForm = Backbone.Form.extend({
    templates: _.extend({}, Backbone.Form.prototype.templates, {
      base: contact_form_tpl,
    }),

    events: {
      'input input': `_handle_input_change`,
      'submit form': `_handle_submit`,
      'click .exit': `hide`,
    },

    initialize(options) {
      if (options.marketo_form_name && (`is_anonymous` in options
         || `user_name` in options
         || `user_email` in options
         || `pricing_tracking_event_name` in options
        )) {
        throw new Error(`You have initialized a ContactForm with options that are useless in a marketo-based configuration`);
      }

      this.$placement_el = options.$placement_el;
      this.contactFormHeaderType = options.contactFormHeaderType;
      this.contactFormFooterType = options.contactFormFooterType;
      this.is_anonymous = options.is_anonymous;
      this.is_static = options.is_static;
      this.marketo_form_name = options.marketo_form_name || null;
      this.user_name = options.user_name;
      this.user_email = options.user_email;
      this.tracking_properties = {};
      this.pricing_tracking_event_name = options.pricing_tracking_event_name;
      Backbone.Form.prototype.initialize.apply(this, arguments);

      this.endpoint = `/billing/get_quote/`;
      this.event_name = `Submit Lead Form`;
      this.fields = [`name`, `company`, `email`, `phone`, `size`, `message`];
    },

    render_base_template() {
      this.$form = $(this.templates.base({
        contactFormHeaderType: this.contactFormHeaderType,
        contactFormFooterType: this.contactFormFooterType,
        marketo_form_name: this.marketo_form_name,
      }));

      if (!this.marketo_form_name) {
        // render company size dropdown
        var employee_choices = _.map([
          `1`,
          `2-10`,
          `11-50`,
          `51-200`,
          `201-500`,
          `501-1,000`,
          `1,001-5,000`,
          `5,001-10,000`,
          `10,001+`,
        ], function(value, i) {
          return [(i + 1).toString(), value];
        });

        this.employee_dropdown = new mp.widgets.dropdowns.Rounded().create(
          this.$form.find(`#employee-count`),
          employee_choices
        );

        var employee_field = this.$form.find(`.input.size-input`);

        this.employee_dropdown.onchange(_.bind(function(item) {
          employee_field.attr(`value`, item.display_value);
          this.employee_dropdown.label.container.addClass(`selected`);
        }, this));

        this.employee_dropdown.label.container.click(_.bind(function() {
          this.remove_tooltip();
          this.employee_dropdown.label.container.removeClass(`error`);
        }, this));

        this.employee_dropdown.body.label_changed = function(ev, label) {
          this.container.css(`min-width`, label.container.outerWidth());
        };
      }
      this.$el.html(this.$form);
    },

    render_marketo_form() {
      var mkto_form_placeholder_el = this.$el[0].querySelector(`form`);
      var marketo_form_id = {
        contact_us: mp.globals.marketo_contact_us_form_id,
        custom_quote: mp.globals.marketo_custom_quote_form_id,
      }[this.marketo_form_name];
      MktoForms2.loadForm(`//discover.mixpanel.com`, `461-OYV-624`, marketo_form_id, (form) => {
        var mkto_form_el = form.getFormElem()[0];
        // don't even think about setting mkto_form_el.id = `` to support rendering multiple marketo forms of the same ID
        // it will look like it works, but actually you've broken Chrome autofill on all subsequently loaded marketo forms of the same ID (the first one always seems to work fine)
        var stylish_button_el = mkto_form_placeholder_el.querySelector(`button`);
        mkto_form_el.onfocusout = () => {
          mkto_form_el.querySelectorAll(`.mktoError`).forEach(function(error_el) {
            error_el.remove();
          });
        };
        if (stylish_button_el) {
          mkto_form_el.querySelector(`button`).replaceWith(stylish_button_el);
        }
        mkto_form_placeholder_el.replaceWith(mkto_form_el);
        form.onValidate(function(isValid) {
          if (isValid) {
            var fullName = form.vals().completeName;
            if (fullName) {
              var nameComponents = fullName.split(/\s+/);
              form.setValues({
                'FirstName': nameComponents[0],
                'LastName': nameComponents[nameComponents.length - 1],
              });
            }
          }
          form.submittable(isValid);
        });
        form.onSubmit(() => {
          if (this.marketo_form_on_submit_callback) {
            this.marketo_form_on_submit_callback(form);
          }
        });
      });
    },

    set_marketo_form_on_submit_callback(callback) {
      this.marketo_form_on_submit_callback = callback;
    },

    render() {
      this.$placement_el.append(this.$el);
      this.$form.hide();

      var AUTO_CLOSE_DELAY = 3500;

      if (!this.is_anonymous) {
        this.$form.find(`.input.name-input`).val(this.user_name);
        this.$form.find(`.input.email-input`).val(this.user_email);
      }

      this.on(`form_submitted`, function() {
        var employee_value = this.$form.find(`.input.size-input`).val();
        mixpanel.track(this.event_name, _.extend({}, this.tracking_properties, {'Employees': employee_value}));
        if (this.pricing_tracking_event_name) {
          var form_data = this._get_form_data();
          var updated_form_data = {};
          form_data.map(function(m) {
            updated_form_data[`${m.name}`] = m.val;
          });
          updated_form_data[`Contact Us Source`] = this.pricing_tracking_event_name;
          mixpanel.track(`Contact Us Request Submitted`, updated_form_data);
        }
      });

      this.on(`email_sent`, function() {
        // form success
        this.$form.find(`button[type="submit"]`).addClass(`success`);

        var notification = new Backbone.widgets.Notification({
          body: `Thank you for contacting us! We'll be in touch shortly.`,
          type: `success`,
        });

        // we have to put the notif in here even though
        // it isn't part of the widget
        this.$form.append(notification.$el);
        notification.render();

        // hide form if it was successful
        if (!this.is_static) {
          setTimeout(_.bind(this.hide, this), AUTO_CLOSE_DELAY);
        } else {
          setTimeout(_.bind(function() {
            this.$form.find(`button[type="submit"]`).removeClass(`loading success`);
            this.reenable();
          }, this), AUTO_CLOSE_DELAY);
        }
        setTimeout(_.bind(notification.handle_close, notification), AUTO_CLOSE_DELAY);
      });

      this.on(`email_not_sent`, function() {
        // form fail
        var notification = new Backbone.widgets.Notification({
          body: `There was an error submitting your form. Please try again later.`,
          type: `error`,
        });

        // we have to put the notif in here even though
        // it isn't part of the widget
        this.$form.append(notification.$el);
        notification.render();

        // reenable form to be submitted again
        this.reenable();
        // close notification after delay but don't close form
        setTimeout(_.bind(notification.handle_close, notification), AUTO_CLOSE_DELAY);
      });
    },

    validate_element(form_element, form_data) {
      if (form_element.required_field === `required` && !form_element.val) {
        return `Please enter your ` + form_element.display;
      }

      if (form_element.name === `email` && !mp.utility.is_valid_email(form_element.val)) {
        return `Please enter a valid email address`;
      }
    },

    _get_form_data() {
      return _.map(this.fields, function(field) {
        var el = this.$(`.input.` + field + `-input`);
        return {
          el,
          val: el.val(),
          name: field,
          display: el.attr(`display`),
          required_field: el.data(`required_field`),
          type: `inputbox`,
        };
      }, this);
    },

    loading_state() {
      this.$form.find(`button[type="submit"]`).addClass(`loading`);
      this.trigger(`form_submitted`);
    },

    loaded_state() {
      this.$form.find(`button[type="submit"]`).removeClass(`loading`);
    },

    parse_server_success(data) {
      this.trigger(`email_sent`);
    },

    parse_server_error(data) {
      this.trigger(`email_not_sent`);
    },

    show_tooltip(field) {
      this.remove_tooltip();
      this.current_tooltip = $(this.render_template(`tooltip`, field));

      if (field.el) {
        var offset = field.el.position();
        var height = field.el.outerHeight();
        var width = field.el.outerWidth();

        // must render it first in order to calculate width
        field.el.parent().append(this.current_tooltip);
        this.current_tooltip.hide();
        var tooltipWidth = this.current_tooltip.outerWidth();

        var left = ((width - tooltipWidth) / 2);

        this.current_tooltip.css({
          'top': offset.top + height,
          'left': offset.left + left,
        });
        this.current_tooltip.find(`.arrow`).css({
          'left': tooltipWidth / 2,
        });

        this.current_tooltip.show();
        if (field.name === `size`) {
          field.el.parent(`.field`).find(`.rounded_dropdown_label`).addClass(`error`);
        }
        field.el.addClass(`error`);
      }
    },

    remove_tooltip() {
      if (this.current_tooltip) {
        this.current_tooltip.remove();
      }
      this.$(`.input, .rounded_dropdown_label`).removeClass(`error`);
    },

    _handle_input_change(evt) {
      this.remove_tooltip_for_input(this.current_tooltip, evt.target);
    },

    show(tracking_event_name, tracking_event_properties) {
      if (!this.$form) {
        this.render();
      }

      this.$form.show();
      setTimeout(_.bind(function() {
        this.$form.addClass(`visible`);
      }, this), 50);

      if (!this.is_static) {
        $(`body`).css(`overflow`, `hidden`);
        mp.utility.bind_esc(this.cid, this.hide, this);

        // have to do this here, since the modal is not shown until now
        var input_selector = this.is_anonymous ? `.name-input` : `.company-input`;
        this.$form.find(input_selector).focus();
      }

      tracking_event_name = tracking_event_name || `Open Contact Form`;
      mixpanel.track(tracking_event_name, _.extend(this.tracking_properties, tracking_event_properties));
    },

    hide() {
      this.$form.removeClass(`visible`);
      if (this.$form.hasClass(`animated`)) {
        this.$form.one(mp.utility.CSS_TRANSITION_END_EVENTS, _.bind(function(ev) {
          this.$form.hide();
        }, this));
      } else {
        this.$form.hide();
      }
      this.$form.find(`button[type="submit"]`).removeClass(`loading success`);
      this.reenable();
      if (!this.is_static) {
        $(`body`).css(`overflow`, ``);
        mp.utility.unbind_esc(this.cid);
      }
    },

    set_tracking_properties(tracking_properties) {
      this.tracking_properties = _.extend({}, this.tracking_properties, tracking_properties);
    },

  });

  return {
    ContactForm,
  };
});

}.call(window));